// theme.js - Enhanced responsive theme configuration
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,      // Mobile phones (portrait)
      sm: 600,    // Mobile phones (landscape) / Small tablets
      md: 900,    // Tablets / Small laptops
      lg: 1200,   // Desktops / Laptops
      xl: 1536,   // Large desktops / 4K screens
    },
  },
  
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    
    // Responsive typography
    h1: {
      fontSize: '2.5rem',
      '@media (min-width:600px)': {
        fontSize: '3rem',
      },
      '@media (min-width:900px)': {
        fontSize: '3.5rem',
      },
      '@media (min-width:1200px)': {
        fontSize: '4rem',
      },
    },
    h2: {
      fontSize: '2rem',
      '@media (min-width:600px)': {
        fontSize: '2.5rem',
      },
      '@media (min-width:900px)': {
        fontSize: '3rem',
      },
    },
    h3: {
      fontSize: '1.75rem',
      '@media (min-width:600px)': {
        fontSize: '2rem',
      },
      '@media (min-width:900px)': {
        fontSize: '2.25rem',
      },
    },
    h4: {
      fontSize: '1.5rem',
      '@media (min-width:600px)': {
        fontSize: '1.75rem',
      },
    },
    h5: {
      fontSize: '1.25rem',
      '@media (min-width:600px)': {
        fontSize: '1.5rem',
      },
    },
    h6: {
      fontSize: '1rem',
      '@media (min-width:600px)': {
        fontSize: '1.25rem',
      },
    },
    body1: {
      fontSize: '1rem',
      '@media (max-width:600px)': {
        fontSize: '0.875rem',
      },
    },
    body2: {
      fontSize: '0.875rem',
      '@media (max-width:600px)': {
        fontSize: '0.8125rem',
      },
    },
  },
  
  spacing: 8, // Base spacing unit (1 = 8px)
  
  palette: {
    primary: {
      main: '#006D77',
      light: '#83C5BE',
      dark: '#004F55',
      contrastText: '#fff',
    },
    secondary: {
      main: '#E29578',
      light: '#FFDDD2',
      dark: '#C97458',
    },
    background: {
      default: '#f5f7fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
    },
  },
  
  // Global component overrides for responsiveness
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: 'xl',
      },
      styleOverrides: {
        root: {
          paddingLeft: '16px',
          paddingRight: '16px',
          '@media (min-width: 600px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
          '@media (min-width: 1200px)': {
            paddingLeft: '32px',
            paddingRight: '32px',
          },
        },
      },
    },
    
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          padding: '8px 16px',
          '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            padding: '6px 12px',
          },
        },
        sizeLarge: {
          padding: '12px 24px',
          '@media (max-width: 600px)': {
            padding: '10px 20px',
          },
        },
        sizeSmall: {
          padding: '4px 10px',
          '@media (max-width: 600px)': {
            padding: '3px 8px',
          },
        },
      },
    },
    
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          '@media (max-width: 600px)': {
            borderRadius: '8px',
          },
        },
      },
    },
    
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            '@media (max-width: 600px)': {
              fontSize: '0.875rem',
            },
          },
        },
      },
    },
    
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '16px',
          '@media (max-width: 900px)': {
            padding: '12px 8px',
            fontSize: '0.875rem',
          },
          '@media (max-width: 600px)': {
            padding: '8px 4px',
            fontSize: '0.8125rem',
          },
        },
      },
    },
    
    MuiChip: {
      styleOverrides: {
        root: {
          '@media (max-width: 600px)': {
            height: '24px',
            fontSize: '0.75rem',
          },
        },
      },
    },
    
    MuiDialog: {
      styleOverrides: {
        paper: {
          margin: '32px',
          '@media (max-width: 600px)': {
            margin: '16px',
            maxHeight: 'calc(100% - 32px)',
          },
        },
      },
    },
  },
});

export default theme;